<page-content *ngIf="!isError404">
  <header-elitment header>
  </header-elitment>
  <div class="module-content">
    <module-content [title]="pageTitle">
      <mat-form-field class="line">
        <input matInput
               maxlength="255"
               placeholder="{{ 'First_name' | translate }}"
               [formControl]="firstNameFormControl"
               [required]="true"
               (keyup)="onFirstNameChange()"
               [(ngModel)]="user.firstName" />
        <mat-error *ngIf="firstNameFormControl.hasError('required')">{{ 'The_first_name_required' | translate }}</mat-error>
      </mat-form-field>
      <mat-form-field class="line">
        <input matInput
               maxlength="255"
               placeholder="{{ 'Last_name' | translate }}"
               [formControl]="lastNameFormControl"
               [required]="true"
               (keyup)="onLastNameChange()"
               [(ngModel)]="user.lastName" />
        <mat-error *ngIf="lastNameFormControl.hasError('required')">{{ 'The_last_name_required' | translate }}</mat-error>
      </mat-form-field>
      <div class="email-field">
        <mat-form-field class="line">
          <input matInput
                 maxlength="255"
                 [readonly]="true"
                 [disabled]="true"
                 placeholder="{{ 'Email_address' | translate }}"
                 [formControl]="emailFormControl"
                 [(ngModel)]="user.email" />
        </mat-form-field>
        <button mat-mini-fab color="none" class="email-field-button"
                (click)="onEmailChangeClicked()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>
      <!--
      <mat-form-field class="line">
          <textarea matInput
                      class="text-area-unresizable"
                      #userIntroInput
                      matTextareaAutosize
                      placeholder="{{ 'User_intro' | translate }}"
                      (keyup)="onIntroChange()"
                      [(ngModel)]="user.intro"></textarea>
          <mat-hint align="end">{{ userIntroInput.value.length }} / {{ DESCRIPTION_MAX_LENGTH }}</mat-hint>
      </mat-form-field>
      -->
      <mat-form-field class="line">
        <mat-select placeholder="{{ 'Lang' | translate }}"
                    (change)="onLangChange()"
                    [(ngModel)]="user.langId">
          <mat-option *ngFor="let lang of langs" [value]="lang.id">
            {{ lang.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <input-image class="line"
                   [placeholder]="'Avatar'"
                   [allowedExtensions]="usersProvider.AVATAR_ALLOWED_EXTENSIONS"
                   [imageHost]="conf.storageRootUrl"
                   [maxFileSize]="usersProvider.AVATAR_MAX_SIZE"
                   [hint]="'Image_file_hint' | translate:{width: usersProvider.AVATAR_MAX_WIDTH, height: usersProvider.AVATAR_MAX_HEIGHT, size: usersProvider.AVATAR_MAX_SIZE}"
                   (change)="onAvatarImageChange()"
                   [(ngModel)]="avatarImage">
      </input-image>
      <div class="line">
        <button mat-raised-button
                color="default"
                (click)="onChangePasswordClicked()">
          {{ 'Change_password' | translate }}
        </button>
      </div>

      <main-action [title]="'Save'"
                   [icon]="'check'"
                   [color]="'accent'"
                   [isLoading]="isLoading"
                   (click)="onSaveClicked()"
      >
      </main-action>
    </module-content>
  </div>
  <!--
  <div class="module-content">
      <module-content [title]="'Networks'">
          <div *ngIf="userLinksData.length === 0" class="legend">{{ 'No_user_link_yet' | translate }}</div>
          <mat-form-field *ngFor="let userLinkData of userLinksData; let i = index"
                          class="line">
              <img *ngIf="userLinkData.userLink.icon"
                   matPrefix
                   src="{{ conf.assetsUrl + userLinkData.userLink.icon }}"
                   class="user-link-icon" />
              <mat-icon *ngIf="!userLinkData.userLink.icon"
                        matPrefix>
                  public
              </mat-icon>
              <input matInput
                     maxlength="255"
                     placeholder="{{ userLinkData.userLink.name }}"
                     [formControl]="userLinkFormControls[i]"
                     (change)="onUserLinksChanged()"
                     [(ngModel)]="userLinkData.user_userLink.link" />
              <mat-hint>{{ userLinkData.userLink.hint }}</mat-hint>
              <mat-error *ngIf="userLinkFormControls[i].hasError('wrongLink')">{{ 'Invalid_link_hint' | translate:{ hint: userLinkData.userLink.hint } }}</mat-error>
          </mat-form-field>
      </module-content>
  </div>
  -->
  <!--    <main-action [displayMode]="'fab'"-->
  <!--                 [title]="'Save'"-->
  <!--                 [isLoading]="isLoading"-->
  <!--                 [icon]="'check'"-->
  <!--                 [disabled]="isLoading || !isFormValid()"-->
  <!--                 (onAction)="onSaveClicked()">-->
  <!--    </main-action>-->
  <footer footer></footer>

</page-content>
<error-404 *ngIf="isError404"></error-404>
